import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { TranslateService } from '@ngx-translate/core';

import { QuotesService } from '@app/core/quotes';

@Component({
  selector: 'cnc-price-negotiations',
  templateUrl: './price-negotiations.component.html',
  styleUrls: ['./price-negotiations.component.scss'],
})
export class PriceNegotiationsComponent implements OnInit {
  qRecord :any;
  loading :boolean = false;

  filter :any = {};
  showFilter :boolean = false;

  pageTitle :string = this.translate.instant('MESSAGING.CLIENT_MESSAGES');
  pageSize = 25;
  pageSizeOptions :number[] = [5, 10, 25, 100];
  params :any = {
    per_page: 25,
    page: 1,
  };

  constructor(
    private quoteSvc :QuotesService,
    private cd :ChangeDetectorRef,
    private translate :TranslateService,
  ) {}

  ngOnInit() {
    this.getRecords();
  }

  getRecords(event ?:PageEvent, page ?:number) {
    const params :any = { page: 1, per_page: this.pageSize };

    if (page) {
      params.page = page;
    }
    if (this.filter.date) {
      params.date = this.filter.date;
    }
    if (this.filter.client) {
      params.client = this.filter.client;
    }
    if (this.filter.product) {
      params.product = this.filter.product;
    }

    if (event) {
      params.page = event.pageIndex + 1;
      params.per_page = event.pageSize;
    }
    this.loading = true;
    this.quoteSvc.getQuotationNegotiations(params).subscribe((resp) => {
      // console.log(resp);
      this.qRecord = resp;
      this.loading = false;
      this.cd.detectChanges();
    });
  }
}
